import SystemPlaylistFullView from './SystemPlaylistFullView'

export default SystemPlaylistFullView
